import { render, staticRenderFns } from "./LiveDataTime.vue?vue&type=template&id=0e80a8a9&scoped=true"
import script from "./LiveDataTime.vue?vue&type=script&lang=js"
export * from "./LiveDataTime.vue?vue&type=script&lang=js"
import style0 from "./LiveDataTime.vue?vue&type=style&index=0&id=0e80a8a9&prod&scoped=true&lang=css"
import style1 from "./LiveDataTime.vue?vue&type=style&index=1&id=0e80a8a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e80a8a9",
  null
  
)

export default component.exports